import { useState } from 'react';
import { Box, Text, HStack, Icon, Collapsible, Button } from '@chakra-ui/react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { FagUrgency } from '@/constants/fagUrgency';

const FaqItem = ({
  question,
  answer,
  icon,
  urgency = FagUrgency.Normal,
}: {
  question: string;
  answer: string | React.ReactNode;
  icon: React.ReactNode;
  urgency?: FagUrgency;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const getUrgencyColor = () => {
    switch (urgency) {
      case FagUrgency.Emergency:
        return 'red';
      case FagUrgency.Urgent:
        return 'orange';
      case FagUrgency.Normal:
        return 'gray';
    }
  };

  return (
    <Box border="1px solid" borderColor="border" borderRadius="md" mb={3} overflow="hidden">
      <Collapsible.Root open={isOpen} onOpenChange={({ open }) => setIsOpen(open)}>
        <Collapsible.Trigger asChild>
          <Button
            variant="ghost"
            width="100%"
            justifyContent="flex-start"
            p={{ base: 3, md: 4 }}
            h="auto"
            _hover={{ bg: 'bg.subtle' }}
          >
            <HStack gap={{ base: 2, md: 3 }} width="100%">
              <Icon color={`${getUrgencyColor()}.500`} boxSize={4} flexShrink={0}>
                {icon}
              </Icon>
              <Text
                fontWeight="medium"
                fontSize={{ base: 'sm', md: 'md' }}
                textAlign="left"
                flex="1"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {question}
              </Text>
              <Icon boxSize={4} color="fg.muted" flexShrink={0}>
                {isOpen ? <ChevronDown /> : <ChevronRight />}
              </Icon>
            </HStack>
          </Button>
        </Collapsible.Trigger>

        <Collapsible.Content>
          <Box px={{ base: 3, md: 4 }} py={{ base: 3, md: 4 }}>
            {typeof answer === 'string' ? (
              <Text color="fg.muted" fontSize="md">
                {answer}
              </Text>
            ) : (
              answer
            )}
          </Box>
        </Collapsible.Content>
      </Collapsible.Root>
    </Box>
  );
};

export default FaqItem;
